import React from 'react';
import styled from '@emotion/styled';
import { Fade, Grid, Typography } from '@mui/material';
import { insertWordBreaks } from '../../../_utils/utils';
import FileType from '../../_common/Icons/FileType';
import RemoveButton from '../../_common/IconButtons/RemoveButton';
import { formatBytes } from '@/_utils/utils';

const DroppedFile = ({ file, onRemove, index = 1 }) => {
  return (
    <Fade in={!!file.name} timeout={index * 300}>
      <div>
        <File container alignItems="center" flexWrap="nowrap">
          <FileType type={file.type} height={35} />
          <Grid item sx={{ ml: 2, mr: 'auto' }}>
            <Typography variant="body2" sx={{ fontSize: '1.1rem' }}>
              <strong>{insertWordBreaks(file.name)}</strong>
            </Typography>
            <Typography variant="caption">{formatBytes(file.size)}</Typography>
          </Grid>
          <RemoveButton onClick={() => onRemove(file)} />
        </File>
      </div>
    </Fade>
  );
};

export default DroppedFile;

const File = styled(Grid)`
  ${({ theme }) => `
    padding: ${theme.spacing(2)};
    margin: ${theme.spacing(0.5, 0)};
    border-radius: ${theme.shape.borderRadius}px;
    width: 100%;
    background-color: ${theme.palette.background.default};
    border: 1px solid transparent;
    transition: border-color 0.4s ease;
    &:hover {
      border-color: ${theme.palette.primary.dark};
      transition: border-color 0.3s ease;
    }
  `}
`;
